import Login from '../views/ParentLogin'
import Signup from '../views/Signup'
import Support from '../views/support/Support'
import AccountSettings from '../views/account/AccountSettings'
import LessonList from '../views/lessons/List'
import Children from '../views/children/Children'
import Overview from '../views/dashboard/Overview'
import ForgotPassword from '../views/ParentForgotPassword'
import ParentDashboard from '../views/ParentDashboard'
import ResetPassword from '../views/ParentResetPassword'

export default [
  {
    path: '/parent/dashboard',
    name: 'Parent Dashboard',
    component: ParentDashboard,
    redirect: '/parent/dashboard/overview',
    meta: {
      private: true,
      type: 'parent'
    },
    children: [
      {
        path: 'overview',
        name: 'Parent Dashboard Overview',
        component: Overview,
        meta: {
          type: 'parent'
        }
      },
      {
        path: 'lessons',
        name: 'Parent Lessons',
        component: LessonList,
        meta: {
          type: 'parent'
        }
      },
      {
        path: 'children',
        name: 'Parent Children',
        component: Children,
        meta: {
          type: 'parent'
        }
      },
      {
        path: 'support',
        name: 'Parent Support',
        component: Support,
        meta: {
          type: 'parent'
        }
      },
      {
        path: 'account',
        name: 'Parent Account',
        component: AccountSettings,
        meta: {
          type: 'parent'
        }
      }
    ]
  },
  {
    path: '/parent/login',
    name: 'Parent Login',
    component: Login,
    meta: {
      type: 'parent'
    }
  },
  {
    path: '/parent/signup',
    name: 'Parent Signup',
    component: Signup,
    meta: {
      type: 'parent'
    }
  },
  {
    path: '/parent/forgotpassword',
    name: 'Parent Password Reset',
    component: ForgotPassword,
    meta: {
      type: 'parent'
    }
  },
  {
    path: '/parent/reset-password',
    name: 'Parent Resert Passowrd',
    component: ResetPassword,
    meta: {
      type: 'parent'
    }
  }
]
